import { createColumnHelper } from "@tanstack/react-table";
import { formatPrice, formatSize, toNumber } from "#/lib/formatters";

export type PortfolioOpenOrderRow = {
	oid: number;
	coin: string;
	side: string;
	orderType: string;
	sz: string;
	limitPx: string;
};

const col = createColumnHelper<PortfolioOpenOrderRow>();

export function createPortfolioOpenOrderColumns(t: (key: string) => string) {
	return [
		col.accessor("coin", {
			header: () => t("portfolio.market"),
			cell: (info) => (
				<span className="text-label2-medium">{info.getValue()}-PERP</span>
			),
		}),
		col.display({
			id: "side",
			header: () => t("portfolio.side"),
			cell: ({ row }) => {
				const isBuy = row.original.side === "B";
				return (
					<span
						className={`text-label2-medium ${isBuy ? "text-trade-green" : "text-trade-red"}`}
					>
						{isBuy ? t("general.buy") : t("general.sell")}
					</span>
				);
			},
		}),
		col.accessor("orderType", {
			header: () => t("portfolio.type"),
			cell: (info) => (
				<span className="text-muted-foreground">{info.getValue()}</span>
			),
		}),
		col.accessor("sz", {
			header: () => t("portfolio.size"),
			cell: (info) => (
				<span className="text-right text-label2-tabular-medium">
					{formatSize(toNumber(info.getValue()))}
				</span>
			),
		}),
		col.accessor("limitPx", {
			header: () => t("portfolio.price"),
			cell: (info) => (
				<span className="text-right text-label2-tabular-medium">
					{formatPrice(info.getValue())}
				</span>
			),
		}),
	];
}
